<script setup>
import { Card, Toggle, Hints, Heading, Buttons, Alert, Button, Preview, Range, DarkModeSwitch, Icon } from '@components'
import DarkModeStore from '@o/store'
import { ref, watch, computed, onMounted } from 'vue'
const { options, showModal, isPro, isLocked } = DarkModeStore()

// watch(() => options.typography_enabled, (val) => {

//     if (!isPro) return;

//     if (val === false) {
//         showModal({
//             title: 'Do you want to disable Typography settings?',
//             message: 'Disabling typography settings will not make the text size increase automatically when text toggle is pressed on accessibility switches',
//             confirmText: 'Disable',
//             cancelText: 'Cancel',
//             cancel: () => {
//                 options.typography_enabled = true
//             }
//         })
//     }
// })

const changeTypography = () => {

    Log(options.typography_enabled)

    if ( isLocked ) {
        options.typography_enabled = false
        return;
    }

    if ( options.typography_enabled ) {
        showModal({
            title: 'Do you want to disable Typography settings?',
            message: 'Disabling typography settings will not make the text size increase automatically when text toggle is pressed on accessibility switches',
            confirmText: 'Disable',
            cancelText: 'Cancel',
            confirm: () => {
                options.typography_enabled = false
            },
            cancel: () => {
                options.typography_enabled = true
            }
        })

        return;
    } else {
        options.typography_enabled = true
    }
}


const calculateFontSize = (size, multiply = 1) => {
    // Size can be in px, em, rem, pt, pc, cm, mm, in, ex, ch, vw, vh, vmin, vmax, %
    // We will multiply the size with the given value with the unit

    const unit = size.replace(/[0-9]/g, '');
    const value = parseFloat(size.replace(/[a-z]/g, ''));
    const newValue = value * multiply;
    return `${newValue}${unit}`;
}


const toggleFontSize = () => {
    const elements = document.querySelectorAll('.wp-dark-mode-accessibility-preview *');

    // Bail if no elements found
    if (!elements) return;

    elements.forEach(element => {
        const fontSize = element.style.getPropertyValue('--wp-dark-mode-font-size');
        if (fontSize) {
            const newFontSize = calculateFontSize(fontSize, previewFontSize.value);
            element.style.cssText += `font-size: ${newFontSize} !important;`;
        }
    });
}

const initPreviewFont = () => {
    const elements = document.querySelectorAll('.wp-dark-mode-accessibility-preview *');

    // Bail if no elements found
    if (!elements) return;

    elements.forEach(element => {
        const fontSize = getComputedStyle(element).fontSize;
        if (fontSize) {
            element.style.setProperty('--wp-dark-mode-font-size', fontSize);
        }
    });
}

onMounted(initPreviewFont)
onMounted(toggleFontSize)

// watch(() => options.typography_font_size, toggleFontSize)
// watch(() => options.typography_font_size_custom, toggleFontSize)

const fontSizes = [
    {
        name: 'Small',
        value: '.8',
    },
    {
        name: 'Medium',
        value: '1.2',
    },
    {
        name: 'Large',
        value: '1.4',
    },
    {
        name: 'Custom',
        value: 'custom',
    }
]

const previewFontSize = computed(() => {
    if (options.typography_font_size === 'custom') {
        return (options.typography_font_size_custom || 100) / 100;
    }
    return options.typography_font_size
})

const home_url = computed(() => {
    return wp_dark_mode_admin_json.paths.home
})

const scrollToAccessibility = () => {
    setTimeout(() => {
        const el = document.getElementById('accessibility-switches');
        // Log('Scrolling to accessibility', el)
        if (el) {
            el.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center',
                inline: 'center', });

            // Add a class to highlight the element
            el.classList.add('wp-dark-mode-highlight')

            // Remove the class after 1 second
            setTimeout(() => {
                el.classList.remove('wp-dark-mode-highlight')
            }, 2000)
        }
    }, 100)
}

</script>
<template>
    <Card transparent borderless class="gap-5">
        <Heading>Typography Settings</Heading>
        <Alert class="text-xs flex items-center justify-between gap-2"> Typography features are only available for
            <strong>Accessibility Switches</strong>
            <template #button>
                <RouterLink to="/switch">
                    <Button class="text-xs whitespace-nowrap" color="warning" @click="scrollToAccessibility"> Explore
                        Accessibility Switches
                        <Icon name="chevronRight" />
                    </Button>
                </RouterLink>
            </template>
        </Alert>
        <Card locked>
            <div class="flex flex-col sm:flex-row gap-6 sm:justify-between">
                <Card borderless transparent class="gap-5">
                    <Card transparent borderless>
                        <div @click.prevent="changeTypography">
                        <Toggle class="pointer-events-none cursor-pointer" locked v-model="options.typography_enabled">Adjust Typography for Dark Mode</Toggle> </div>
                        <Hints locked>Enable to get seamless readability by font adaptation during dark-light mode toggling.
                        </Hints>
                    </Card>
                    <Row transparent borderless v-if="options.typography_enabled" locked :ProBadge="false">
                        <Heading>Font Size <Hints>Choose the size of the floating toggle switch.</Hints>
                        </Heading>
                        <Buttons @change="toggleFontSize" :options="fontSizes" v-model="options.typography_font_size">
                        </Buttons>
                        <Card dark v-if="options.typography_font_size === 'custom'" class="flex flex-col gap-2">
                            <Hints>Scale in percentage relative to normal size</Hints>
                            <Range default="100" :min="50" :max="300" step="1" placeholder="Custom size"
                                @change="toggleFontSize" v-model="options.typography_font_size_custom">
                            </Range>
                        </Card>
                    </Row>
                </Card>
                <Card v-if="options.typography_enabled" borderless class="wp-dark-mode-accessibility-preview">
                    <Preview dark>
                    </Preview>
                </Card>
            </div>
        </Card>
        <div class="my-1"></div>
        <Heading>Other Accessibility Settings</Heading>
        <Card class="gap-5">
            <Card transparent borderless>
                <Toggle v-model="options.accessibility_enabled_keyboard_shortcut">Keyboard Shortcut</Toggle>
                <Hints>Enable keyboard shortcut to toggle dark mode <span class="bg-gray-100 p-1">Ctrl + Alt + D</span>
                </Hints>
            </Card>
            <Card transparent borderless>
                <Toggle v-model="options.accessibility_enabled_url_param">URL Parameter</Toggle>
                <Hints>Enable/Disable the dark mode using URL/domain parameter</Hints>
                <Hints>Use <span class="bg-gray-100">{{ home_url }}?darkmode</span> to enable dark mode and <span
                        class="bg-gray-100">{{ home_url }}?lightmode</span> to enable light mode</Hints>
            </Card>
        </Card>
    </Card>
</template>

<style scoped>
.wp-dark-mode-accessibility-preview * {
    font-size: var(--wp-dark-mode-font-size, 'initial') !important;
    line-height: initial !important;
    transition: all 0.2s !important;
}

.wp-dark-mode-accessibility-preview .text-3xl {
    line-height: initial !important;
}
</style>